export default defineNuxtPlugin(() => {
  checkEnabledCookies()
})
